import { ChangeEvent } from 'react';
import { TextField } from '../../../../2-component';

interface CurrencyInputProps {
  positiveMax?: number;
  negativeMax?: number;
  onChange: (value: number) => void;
  value?: number;
  placeholder?: string;
}

export const CurrencyInput = ({
  positiveMax, negativeMax, onChange, value, placeholder,
}: CurrencyInputProps) => (
  <TextField
    type='dollar'
    value={value?.toString() || ''}
    onChange={(e: ChangeEvent<HTMLInputElement>) => {
      const { valueCents } = e.target as any;
      onChange(valueCents ? valueCents / 100 : 0);
    }}
    placeholder={placeholder}
  />
);
